import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';
import { apiPlacesSearch } from '../../shared/utils/api/placesSearch';
import { ConfigContext } from '../ConfigContext';

const LocationFilter = ({ location, apiKey, provider, onChange, setLoadingCaption }) => {
  const [locations, setLocations] = useState(null);
  const config = useContext(ConfigContext);

  useEffect(() => {
    (async () => {
      const locations = await apiPlacesSearch(apiKey, provider, {
        activityPrefLabel: config.activity,
      });
      const mappedLocations = {};

      if (typeof locations !== 'object' || !(locations['imin:item'] instanceof Array)) {
        return;
      }

      for (const location of locations['imin:item']) {
        let label = location.name;
        if (label === null) {
          const streetAddressArr = location.address.streetAddress.split(',');
          label = streetAddressArr[0].trim();
        }
        for (const location of locations['imin:item']) {
          let label = location.name;
          if (label === null) {
            const streetAddressArr = location.address.streetAddress.split(',');
            label = streetAddressArr[0].trim();
          }
          let value = `${location.geo.latitude},${location.geo.longitude},0`;
          mappedLocations[label] = value;
        }
      }

      const dedupedMappedLocations = [];
      Object.keys(mappedLocations).map((label) => {
        dedupedMappedLocations.push({ label, value: mappedLocations[label] });
      });

      dedupedMappedLocations.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });

      setLocations(dedupedMappedLocations);
      setLoadingCaption('Please select a location above to see results...');
    })();
  }, []);

  const doLocationChange = (value) => {
    if (location !== value && typeof onChange === 'function') {
      onChange(value);
    }
  };

  let caption = 'Select a location';
  if (locations instanceof Array) {
    if (!locations.length) {
      caption = 'No locations found';
    }
  } else {
    caption = 'Loading...';
  }

  return (
    <Filter
      id="Location"
      defaultCaption={caption}
      value={location}
      onChange={doLocationChange}
      options={locations}
    />
  );
};

LocationFilter.propTypes = {
  apiKey: PropTypes.string,
  provider: PropTypes.string,
  location: PropTypes.string,
  onChange: PropTypes.func,
  setLoadingCaption: PropTypes.func,
};

export default LocationFilter;
